import { Fragment, useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from "react-redux"
import { useForm, Controller } from 'react-hook-form'
import { DefaultConfig } from '../../settings/config'
import { useParams, useNavigate, Link } from 'react-router-dom'
import * as yup from "yup"
import { GetUserDetailsById, UpdateUser, UpdateUserAddress, CreateAddress, GetAgentDetails, CreateUserCompanyMapping, UpdateUserCompanyMappingById, InviteUser } from '../redux/store'
import classnames from 'classnames'
import { yupResolver } from "@hookform/resolvers/yup"
import { isObjEmpty, selectThemeColors } from '@utils'
import Select, { components } from 'react-select'
import { Row, Col, Button, Label, Input, Form, FormFeedback, Spinner, Modal, ModalHeader, ModalBody, ModalFooter, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Accordion, AccordionBody, AccordionHeader, AccordionItem, UncontrolledTooltip } from 'reactstrap'
import { Edit, Plus, Trash2, RefreshCcw, X, Calendar } from "react-feather"
import CustomValueContainer from "../Components/Select"
import SourceSystemCustomContainer from '../Components/CustomSelect'
import ComponentSpinner from '../../components/spinner/Loading-spinner'
import Sidebar from '../Components/SideBar'
import { isUserLoggedIn } from "../../@core/auth/utils"
import ToastMessage from "../../components/toast-messages"
import toast from "react-hot-toast"
import '@styles/react/libs/flatpickr/flatpickr.scss'
import Flatpickr from 'react-flatpickr'

const ActiveUserDesign = () => {
  const loggedinUserDetails = isUserLoggedIn() && JSON.parse(isUserLoggedIn())
  const dispatch = useDispatch()
  const stores = useSelector((state) => state.commonreducerSlice)
  const [stateOptions, setStateOptions] = useState([])
  const selectStyles = DefaultConfig().selectStyles
  const selectStyles1 = DefaultConfig().selectStyles1
  const [email, setEmail] = useState("")
  const [firstName, setFirstName] = useState("")
  const [lastName, setLastName] = useState("")
  const [address, setAddress1] = useState('')
  const [address2, setAddress2] = useState('')
  const [city, setCity] = useState('')
  const navigate = useNavigate()
  const [countryData, setCountryData] = useState(null)
  const specialCharacterPattern = DefaultConfig().specialCharacterPattern
  const specialCharacterErrorMessage = DefaultConfig().specialCharacterErrorMessage
  const { id } = useParams()
  const [spinnerStatus, setSpinnerStatus] = useState(false)
  const [sidebarSpinnerStatus, setSidebarSpinnerStatus] = useState(false)
  const [spinnerUStatus, setUSpinnerStatus] = useState(true)
  const [stateData, setStateData] = useState(null)
  const [userIdData, setUserIdData] = useState(null)
  const sorter = DefaultConfig().sorter
  const optionAdrress = DefaultConfig().optionAdrress
  const DepartmentMapping = DefaultConfig().DepartmentMapping
  const userWriterRole = DefaultConfig().UserWriterRole
  const SourceSystem = DefaultConfig().SourceSystem
  const formattedDateIssueFixed = DefaultConfig().formattedDateIssueFixed
  //const [isEdited, setIsEdited] = useState(false)
  const [backupData, setBackupData] = useState([])
  const [errorMessage, setErrorMessage] = useState([])
  const [statusOption, setStatus] = useState(null)
  const [spinnerArray, setSpinnerArray] = useState([])
  const [userDetailsDisabling, setUserDetailsDisabling] = useState(false)
  const [show, setShow] = useState(false)
  const [editingElement, setEditingElement] = useState([])
  const [sideBarValue, setSideBarValue] = useState("")
  const [sideBarIndex, setSideBarIndex] = useState("")
  const [listAgentIds, setListAgentId] = useState([])
  const [agentInput, setAgentInput] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [addCompanyOption, setAddCompanyOption] = useState(false)
  const [companyData, setCompanyData] = useState([])
  const [modal, setModal] = useState(false)
  const [modalSpinnerStatus, setMOdalSpinnerStatus] = useState(false)
  const [modalInvite, setModalInvite] = useState(false)
  const [agentObj, setAgentObj] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [addressStatus, setAddressStatus] = useState(true)
  const [disIndex, setDisIndex] = useState("notRequired")
  const [isAgentSelected, setIsAgentSelected] = useState(false)
  const [isSourceSystemSelected, setIsSourceSystemSelected] = useState(false)
  const regionalOffices = DefaultConfig().regionalOffices
  const [selectedRegionId, setSelectedRegionId] = useState(-1)
  const [inviteSpinner, setInviteSpinner] = useState(false)
  // const [inviteUserModel, setInviteUserModel] = useState(false)
  const fpRef = useRef(null)
  const fpRefs = useRef({})

  const makeKey = (agentId, id) => `${agentId}_${id}`

  function domain(row) {
    return row?.split("@")[1] === "liscr.com"
  }

  const statusOptions = [
    { value: 'All', label: 'All', id: 3 },
    { value: 'Active', label: 'Active', id: 1 },
    { value: 'InActive', label: 'InActive', id: 2 }

  ]

  const [companyStatus, setCompanyStatus] = useState(statusOptions[0])
  const [agentError, setAgentError] = useState("")
  const [loadingCompanyId, setLoadingCompanyId] = useState(null)


  const ValidSchema = yup.object().shape({

    [`firstName`]: yup.string().trim().nullable().required("First Name is a required field"),
    [`lastName`]: yup.string().trim().nullable().required("Last Name is a required field")

  })

  const options = [
    { value: 'Active', label: 'Active', id: 1 },
    { value: 'InActive', label: 'InActive', id: 2 },
    { value: 'Suspended', label: 'Suspended', id: 3 }
  ]

  const useraddressArray = ["Primary Address", "Shipping Address", "Billing Address"]
  const [addressOption, setAddressOption] = useState(null)
  const [createAddressOption, setCreateAddressOption] = useState(optionAdrress[0])
  const [AgentValidateError, setAgentValidateError] = useState('')

  //filters Components
  const [filterCompanyName, setFilterCompanyName] = useState('')
  const [filterSourceSystemId, setFilterSourceSystemId] = useState(null)
  const [filterAgentId, setFilterAgentId] = useState('')
  const [filteredCompanies, setFilteredCompanies] = useState([])

  const [infoModal, setInfoModal] = useState(false)
  const [actionModal, setActionModal] = useState(false)
  const [actionIndex, setActionIndex] = useState(null)
  const [disableAgentInput, setDisableAgentInput] = useState(false)

  const handleFilterChange = (fieldName, value) => {
    // Create new state values based on current state
    let newCompanyName = filterCompanyName
    let newAgentId = filterAgentId
    let newSourceSystemId = filterSourceSystemId

    // Update the appropriate state based on fieldName
    if (fieldName === 'companyName') {
      newCompanyName = value
      setFilterCompanyName(value)
    } else if (fieldName === 'agentId') {
      newAgentId = value
      setFilterAgentId(value)
    } else if (fieldName === 'sourceSystemId') {
      newSourceSystemId = value
      setFilterSourceSystemId(value)
    }

    // Prepare filter values
    const nameFilter = newCompanyName?.trim().toLowerCase()
    const agentFilter = newAgentId?.trim().toLowerCase()
    const sourceFilter = newSourceSystemId?.id || newSourceSystemId // Handle both object and ID cases

    // Apply filters
    const filtered = userIdData?.userCompanies?.filter(company => {
      const companyNameMatches = !nameFilter ||
        company.companyName?.toLowerCase().includes(nameFilter)

      const sourceSystemMatches = !sourceFilter ||
        company.sourceSystemId === (sourceFilter?.id || sourceFilter)

      const agentIdMatches = !agentFilter ||
        String(company.agentId || '').toLowerCase().includes(agentFilter)

      return companyNameMatches && sourceSystemMatches && agentIdMatches
    }) || [] // Fallback to empty array if null/undefined

    setFilteredCompanies(filtered)
  }

  const { trigger, control,
    setValue,
    getValues,
    formState: { errors, isDirty } } =
    useForm({ mode: 'onChange', resolver: yupResolver(ValidSchema) })

  function countryValues(obj, data) {
    const country = stores?.countryStates.find((item) => item.id === obj.countryId)
    if (!country) return null
    if (data === "country") {

      return country
    } else {
      const states = country.states || []
      const matchingState = states.find((item) => item.name === data)
      if (matchingState) {
        return {
          ...matchingState,
          label: matchingState.name,
          value: matchingState.name
        }
      } else {
        return { value: data, label: data }
      }
    }
  }

  const NoOptionsMessage = (props) => {
    return (
      <components.NoOptionsMessage {...props}>
        {addCompanyOption ? (
          <Fragment>
            No Options
          </Fragment>
        ) : (
          <div>Enter min 3 characters.</div>
        )}
      </components.NoOptionsMessage>
    )
  }

  function getCountry(data) {
    const country = stores?.countryStates.find((item) => item.id === data)

    if (country) {
      return country
    } else {
      return ""
    }
  }

  const addCountryNames = (user) => {
    return [
      ...user.map(address => ({
        ...address,
        userAddress: {
          ...address.userAddress,
          countryName: countryValues(address.userAddress, "country"),
          state: countryValues(address.userAddress, address.userAddress.state),
          isEdit: true
        }
      }))
    ]
  }

  function MappingFunction(data) {
    if (data) {
      if (Object.keys(data).length) {
        setBackupData(addCountryNames(data.userAddresses))
        setErrorMessage(Array(data.userAddresses.length).fill({ address1: '', address2: "", city: "", state: "", country: "" }))
      }

    }
    setSpinnerStatus(false)
  }


  const getNdaData = (data) => {
    const userIdData = { ...data }
    if (userIdData) {
      setUserIdData(userIdData)
      //   setFilteredCompanies(userIdData?.userCompanies || [])
      if (userIdData?.userStatus) {
        const temp = options.find((item) => item.id === userIdData?.userStatus)
        setStatus(temp)
      }
      setAddressOption(optionAdrress[0])
      setFirstName(userIdData.userFirstName ? userIdData.userFirstName : firstName)
      setValue('firstName', userIdData.userFirstName ? userIdData.userFirstName : '')

      setLastName(userIdData.userLastName ? userIdData.userLastName : lastName)
      setValue('lastName', userIdData.userLastName ? userIdData.userLastName : '')

      setEmail(userIdData.userEmail ? userIdData.userEmail : email)
      setValue('lastName', userIdData.userEmail ? userIdData.userEmail : '')

      setSelectedRegionId(userIdData.regionId ?? null)

    }
  }

  useEffect(() => {
    const backupDataSpinner = Array(backupData.length).fill(false)
    setSpinnerArray(backupDataSpinner)
  }, [backupData.length])

  async function fetch(value1, value2) {
    const obj = {}
    obj.id = Number(id)
    obj.isAddressMapping = value2
    if (value1 !== 3) {
      obj.isCompanyMapping = value1 === 1 ? true : value1 === 2 ? false : ""
    }
    setSpinnerStatus(true)
    const response = await dispatch(GetUserDetailsById(obj)).finally(() => {
      setFilterAgentId("")
      setFilterCompanyName("")
      setFilterSourceSystemId(null)
    })
    if (response.payload) {
      setUserIdData(response.payload.data)
      getNdaData(response.payload.data)
      setFilteredCompanies(response.payload?.data?.userCompanies)
      MappingFunction(response.payload.data)
      const backupDataSpinner = Array(response.payload.data.userAddresses.length).fill(false)
      setSpinnerArray(backupDataSpinner)
    } else {
      setSpinnerStatus(false)
    }
  }

  useEffect(() => {
    fetch(companyStatus?.id, addressStatus)
  }, [id])


  function Inputvalidation(updatedData, index, attributeName, countryContain) {
    const newErrorMessage = [...errorMessage]
    const error = {}
    for (let i = 0; i < updatedData.length; i++) {
      if (index === i) {
        if ((updatedData[i]["userAddress"][attributeName] === '') || (updatedData[i]["userAddress"][attributeName] === null)) {
          if (attributeName === "address1") {
            error["address1"] = "Address1 is a Required Field"
            error["city"] = newErrorMessage[index]["city"]
            error["state"] = newErrorMessage[index]["state"]
            error["country"] = newErrorMessage[index]["country"]
          } else if (attributeName === "city") {
            error["city"] = "city is a Required Field"
            error["address1"] = newErrorMessage[index]["address1"]
            error["state"] = newErrorMessage[index]["state"]
            error["country"] = newErrorMessage[index]["country"]
          } else if (attributeName === "countryName") {
            error["country"] = newErrorMessage[index][""]
            error["state"] = ""
            error["address1"] = newErrorMessage[index]["address1"]

            error['city'] = newErrorMessage[index]["city"]
          } else if (attributeName === "state") {
            error["country"] = newErrorMessage[index]['country']
            if (updatedData[i]["userAddress"]?.["countryName"]?.states?.length) {
              error["state"] = "state is a Required Field"
            }
            error["address1"] = newErrorMessage[index]["address1"]

            error['city'] = newErrorMessage[index]["city"]
            error["country"] = newErrorMessage[index]["country"]
          }

        } else {
          if (attributeName === "address1") {
            error["adress1"] = ""
            error["city"] = newErrorMessage[index]["city"]
            error["country"] = newErrorMessage[index]["country"]
            error["state"] = newErrorMessage[index]["state"]
          } else if (attributeName === "city") {
            error["city"] = ""
            error["address1"] = newErrorMessage[index]["address1"]
            error['country'] = newErrorMessage[index]["country"]
            error["state"] = newErrorMessage[index]["state"]
          } else if (attributeName === "countryName") {
            error["country"] = ""
            error["state"] = ""
            error["city"] = newErrorMessage[index]["city"]
            error["address1"] = newErrorMessage[index]["address1"]
          } else if (attributeName === "state") {
            if (countryContain) {
              error["state"] = ""
            } else {
              error["state"] = newErrorMessage[index]["state"]
            }
            error['country'] = newErrorMessage[index]["country"]
            error["city"] = newErrorMessage[index]["city"]
            error["address1"] = newErrorMessage[index]["address1"]

          }
        }
        newErrorMessage[index] = error
      }
    }
    setErrorMessage(newErrorMessage)
  }

  const onChangeInput = (e, index, attributeName) => {
    let updateData = []
    const userAddresses = [...backupData]
    if (e !== null) {
      if (attributeName === "state" && Object.keys(e)?.includes("label")) {
        updateData = userAddresses.map((item, i) => {
          if (index === i) {
            return {
              ...item,
              userAddress: {
                ...item.userAddress,
                state: e
              }
            }
          } else {
            return { ...item }
          }
        })
      }
      if (attributeName === "state" && !Object.keys(e)?.includes("label")) {

        updateData = userAddresses.map((item, i) => {
          if (index === i) {
            return {
              ...item,
              userAddress: {
                ...item.userAddress,
                state: e?.target?.value
              }
            }
          } else {
            return { ...item }
          }
        })
      }
    }

    if (attributeName === "state" && e === null) {

      updateData = userAddresses.map((item, i) => {
        if (index === i) {
          return {
            ...item,
            userAddress: {
              ...item.userAddress,
              state: null
            }
          }
        } else {
          return { ...item }
        }
      })
    }

    if (attributeName === "countryName") {
      updateData = userAddresses.map((item, i) => {
        if (index === i) {
          return {
            ...item,
            userAddress: {
              ...item.userAddress,
              countryName: e,
              state: e?.states?.length ? null : ""
            }
          }
        } else {
          return { ...item }
        }
      })
    }
    if (attributeName === "address1" || attributeName === "city" || attributeName === "address2") {
      const { value } = e.target

      updateData = userAddresses.map((item, i) => {
        if (i === index) {
          return {
            ...item,
            userAddress: {
              ...item.userAddress,
              [attributeName]: value
            }

          }
        }
        return item
      })
    }
    setBackupData(updateData)

    Inputvalidation(updateData, index, attributeName, attributeName === "state" ? e === null ? true : Object.keys(e)?.includes("label") : "")

  }

  async function userUpdateFunction() {
    setUSpinnerStatus(false)
    const obj = {}
    obj["id"] = id
    obj["firstName"] = firstName
    obj["lastName"] = lastName
    obj["email"] = email
    obj["status"] = statusOption.id
    obj["regionId"] = selectedRegionId === -1 ? null : selectedRegionId
    obj.lastModifiedBy = loggedinUserDetails?.userRoles[0]?.userId
    const response = await dispatch(UpdateUser(obj)).finally(() => {
      setUSpinnerStatus(true)
      setMOdalSpinnerStatus(false)
      setInfoModal(false)
      setUserDetailsDisabling(!userDetailsDisabling)
    })
    if (response.payload) {
      fetch(companyStatus?.id, addressStatus)
    }
  }

  function updateEdit(index) {
    const userAddresses = [...backupData]
    setEditingElement(userAddresses[index])
    const updateData = userAddresses.map((item, i) => {
      if (index === i) {
        return {
          ...item,
          userAddress: {
            ...item.userAddress,
            isEdit: true
          }
        }
      } else {
        return { ...item }
      }
    })
    setShow(!show)
    setSideBarIndex(index)
    setSideBarValue("address")
    setBackupData(updateData)
  }

  function validateData(index) {
    const checkingValue = backupData[index]

    const newErrorMessage = [...errorMessage]
    let condition = false
    //const checkingErrorValue = newErrorMessage[index]
    const error = {}

    if (checkingValue) {
      if (!checkingValue.userAddress.city.length) {
        error["city"] = "City is Required Field"
        condition = true
      } else {
        error["city"] = ""
      }
      if (!checkingValue.userAddress.address1.length) {
        error["address1"] = "Address is Required Field"
        condition = true
      } else {
        error["address1"] = ""
      }
      if (checkingValue?.userAddress?.
        countryName) {
        error["country"] = ""
      } else {
        error["country"] = "Country is Required Field"
        condition = true
      }
      if (checkingValue?.userAddress?.countryName?.states?.length && checkingValue?.userAddress.state !== null) {
        error["state"] = ""
      } else if (checkingValue?.userAddress?.countryName?.states?.length && checkingValue?.userAddress.state === null) {
        error["state"] = "State is Required Field"
        condition = true
      } else if (!checkingValue?.userAddress?.countryName?.states?.length) {
        error["state"] = ""
      }
    }
    newErrorMessage[index] = error
    setErrorMessage(newErrorMessage)
    return condition
  }

  async function updateAddressFunction(index) {
    const isEmpty = validateData(index)
    if (!isEmpty) {
      setSidebarSpinnerStatus(true)
      const payloadData = backupData[index]
      const obj = {}

      obj.address1 = payloadData.userAddress.address1
      obj.address2 = payloadData.userAddress.address2
      //  obj.agentId=payloadData?.

      if (payloadData?.newEntry === 1) {
        obj.countryTypeId = payloadData.userAddress.countryName.id
        obj.userId = userIdData?.userId
        obj.isUserAddressMapping = true
        obj.addressType = createAddressOption.id
      } else {

        obj.id = payloadData.userAddressId
        obj.countryId = payloadData.userAddress.countryName.id
        obj.addressTypeId = payloadData.userAddress.addressTypeId
      }
      if (typeof (payloadData.userAddress.state) === "string") {
        obj.state = payloadData.userAddress.state
      } else {
        obj.state = payloadData.userAddress.state.label
      }
      obj.city = payloadData.userAddress.city
      const spinnerValues = [...spinnerArray]
      spinnerValues[index] = !spinnerValues[index]
      setSpinnerArray(spinnerValues)
      let response
      if (payloadData.newEntry !== 1) {
        response = await dispatch(UpdateUserAddress(obj)).finally(() => {

          const spinnerValues = [...spinnerArray]
          spinnerValues[index] = !spinnerValues[index]
          setSpinnerArray(spinnerValues)
          setSidebarSpinnerStatus(false)

        })
      } else {
        response = await dispatch(CreateAddress(obj)).finally(() => {
          const spinnerValues = [...spinnerArray]
          spinnerValues[index] = !spinnerValues[index]
          setSpinnerArray(spinnerValues)
          setSidebarSpinnerStatus(false)

        })
      }
      if (response.payload) {
        fetch(companyStatus?.id, addressStatus)
        setShow(!show)
        setEditingElement([])
        setSideBarIndex("")
        setSideBarValue("")
      }
    }
  }

  async function AgentCallFunction() {

    if (listAgentIds.length) {
      setSidebarSpinnerStatus(true)

      const data = {
        userId: Number(id),
        agentIds: listAgentIds.map(agent => ({
          agentId: String(agent.agentId),
          agentName: agent.name,
          sourceSystems: [...new Set(agent.classId)].map(cls => ({ sourceSystemId: cls, endDate: (agent?.endDates?.find(find => find.id === cls) ? agent?.endDates?.find(find => find.id === cls)?.endDate : null) })),
          gPClientDepartmentId: Number(agent.gpClassId)
        }))
      }
      // const data = {
      //     userId: Number(id),
      //     agentIds: listAgentIds.map(agent => {
      //         const classIds = agent.classId
      //         const sourceSystemId = Array.isArray(classIds) && classIds.length > 0 ? classIds : 0
      //         return {
      //             agentId: agent.agentId,
      //             agentName: agent.name,
      //             sourceSystemId,
      //             gPClientDepartmentId: sourceSystemId
      //         }
      //     })
      // }
      const response = await dispatch(CreateUserCompanyMapping(data)).finally(() => {
        setSidebarSpinnerStatus(false)
      })
      if (response.payload) {
        fetch(companyStatus?.id, addressStatus)
        setAgentError("")
        setShow(!show)
        setEditingElement([])
        setSideBarIndex("")
        setSideBarValue("")
        setListAgentId([])
        setEndDate(null)
      }
    } else {
      setAgentError("Please Select Agents")
    }
  }

  function handleReset(cancelData) {
    if (sideBarValue === "address") {
      const bufferData = [...backupData]
      bufferData[sideBarIndex] = editingElement
      if (bufferData[sideBarIndex].newEntry && cancelData === "cancel") {
        bufferData.splice(0, 1)
        setBackupData(bufferData)
      } else {

        const updateData = bufferData.map((item, i) => {
          if (sideBarIndex) {

            if (sideBarIndex === i) {
              return {
                ...item,
                userAddress: {
                  ...item.userAddress,
                  isEdit: true
                }
              }
            } else {
              return { ...item }
            }
          } else {
            return { ...item }
          }

        })
        setBackupData(updateData)
      }
    } else {
      setListAgentId([])
    }
    setDisableAgentInput(false)
    setAgentValidateError("")
    setEditingElement([])
    setSideBarIndex("")
    setSideBarValue("")
    setAgentError("")
    setListAgentId([])
    setEndDate(null)
  }

  const toggleSidebar = () => {
    setShow(!show)
    handleReset("cancel")
  }

  function cancel() {
    setUserDetailsDisabling(!userDetailsDisabling)
    getNdaData(userIdData)
  }

  function updateNo() {

    if (modal) {
      setModal(false)
    } else if (infoModal) {
      setInfoModal(false)
      cancel()
    } else {
      setActionModal(false)
      setActionIndex(null)
    }
    if (modalInvite) {
      setModalInvite(false)
    }
  }

  const MakeInActive = async (value1, value2, sourceSystem) => {
    // setLoadingCompanyId(value1)
    const obj = {}
    obj.userId = Number(id)
    obj.companyId = value1
    obj.isActive = !value2
    obj.sourceSystemId = sourceSystem
    obj.userEmail = email
    obj.lastModifiedBy = loggedinUserDetails?.userRoles[0]?.userId
    const response = await dispatch(UpdateUserCompanyMappingById(obj)).finally(() => {
      setLoadingCompanyId(null)
      setMOdalSpinnerStatus(false)
      setActionModal(false)
    })
    if (response.payload) {
      fetch(companyStatus?.id, addressStatus)
    }
  }

  async function updateYes() {
    setMOdalSpinnerStatus(true)
    if (modal) {
      const payloadData = backupData[sideBarIndex]
      const obj = {}
      obj.address1 = payloadData.userAddress.address1
      obj.address2 = payloadData.userAddress.address2
      obj.id = payloadData.addressTypeId
      obj.countryId = payloadData.userAddress.countryName.id
      obj.addressTypeId = payloadData.userAddress.addressTypeId
      obj.city = payloadData.userAddress.city
      if (typeof (payloadData.userAddress.state) === "string") {
        obj.state = payloadData.userAddress.state
      } else {
        obj.state = payloadData.userAddress.state.label
      }
      obj.isAddressActive = false
      await dispatch(UpdateUserAddress(obj)).finally(() => {
        setMOdalSpinnerStatus(false)
        setModal(!modal)
        setTimeout(() => {
          fetch(companyStatus?.id, addressStatus)
        }, 300)
      })
    } else if (infoModal) {
      userUpdateFunction()
    } else if (modalInvite) {
      setInviteSpinner(true)
      const response = await dispatch(InviteUser({ userEmail: email, userFirstName: firstName, UserLastName: lastName })).finally(() => {
        setInviteSpinner(false)
        setMOdalSpinnerStatus(false)
        setModalInvite(false)
      })
      if (response.payload) {
        toast(t => (<ToastMessage t={t} message={"Email Sent Successfully"} status={"success"} />))
      }
    } else {
      setTimeout(() => {
        const company = filteredCompanies[actionIndex]
        MakeInActive(company.companyId, company.isActive, company.sourceSystemId)
      }, 100)
    }
  }

  const handleInputChange = (inputValue, action) => {
    if (action?.action !== "input-blur" && action?.action !== "menu-close") {
      setAgentInput(inputValue)
    }
  }

  useEffect(() => {
    if (agentInput.length > 2) {
      setIsLoading(true)
      const timer = setTimeout(() => {
        const searchOptions = async () => {
          if (agentInput) {
            const responseData = await dispatch(GetAgentDetails(agentInput))
            const companyData = responseData.payload
            if (companyData) {
              const sfCompanys = []
              if (companyData.length > 0) {
                companyData.forEach((item) => {
                  if (item.customerNumber) {
                    sfCompanys.push({ value: item.customerNumber, label: `${item.customerName} ${item.customerNumber !== null ? `(${item.customerNumber})` : ''}`, name: item.customerName, agentId: item.customerNumber, classId: item.customerClassId, gpClassId: item.customerClassId })
                  }
                })
              } else {
                setAddCompanyOption(true)
              }
              setCompanyData(sfCompanys)
              setIsLoading(false)
            }
          }
        }
        if (agentInput) {
          setIsLoading(true)
          setAddCompanyOption(false)
          searchOptions()
        } else {
          setIsLoading(false)
          setCompanyData([])
        }
      }, 500)
      return () => clearTimeout(timer)
    } else {
      setIsLoading(false)
      setCompanyData([])
      setAddCompanyOption(false)
    }
  }, [agentInput])

  const handleDelete = (index) => {
    const newItems = [...listAgentIds]
    const deletedAgent = listAgentIds[index]
    newItems.splice(index, 1)
    if (AgentValidateError.includes(deletedAgent.agentId)) {
      setAgentValidateError('')
      setDisableAgentInput(false)
      setDisIndex("notRequired")
    }
    if (index === disIndex || (listAgentIds[disIndex] && newItems.filter((item) => item.classId === listAgentIds[disIndex].classId && item.agentId === Number(listAgentIds[disIndex].agentId)).length <= 1)) {
      setAgentValidateError("")
      setDisableAgentInput(false)
      setDisIndex("notRequired")
    } else if (index < disIndex) {
      setDisIndex(disIndex => disIndex - 1)
    }
    setListAgentId(newItems)

  }

  // const handleCheckboxChange = () => {
  //     setCompanyStatus(!companyStatus)
  //     fetch(companyStatus, addressStatus)
  // }

  const handleCheckboxChange1 = () => {
    setAddressStatus(!addressStatus)
    fetch(companyStatus?.id, !addressStatus)
  }

  // const handleSourceSystemChange = (index, selectedOption) => {
  //     console.log(selectedOption, 'selectedOption')

  //     const updatedList = listAgentIds.map((agent, i) => {
  //         if (i === index) {
  //             return { ...agent, classId: selectedOption.id }
  //         }
  //         return agent
  //     })

  //     setListAgentId(updatedList)
  //     const currentAgent = updatedList[index]

  //     const existingData = userIdData?.userCompanies?.filter((item) => Number(item.agentId) === Number(currentAgent.agentId) && item.sourceSystemId === currentAgent.classId)

  //     const fitlerArray = updatedList.filter((item) => item.classId === currentAgent.classId && Number(item.agentId) === Number(currentAgent.agentId))

  //     if (existingData.length > 0) {
  //         setAgentValidateError(`Agent(${currentAgent.agentId}) with same Source System (${SourceSystem(currentAgent?.classId)?.label})  already exists.`)
  //         setDisableAgentInput(true)
  //         if (updatedList.length > 1) {
  //             setDisIndex(index)
  //         } else {
  //             setDisIndex("notRequired")
  //         }
  //     } else {
  //         if (fitlerArray.length > 1) {
  //             setDisIndex(index)
  //             setAgentValidateError(`Agent(${currentAgent.agentId}) with same Source System (${SourceSystem(currentAgent.classId)?.label})  already selected.`)
  //             setDisableAgentInput(true)
  //         } else {
  //             setDisIndex("notRequired")
  //             setAgentValidateError('')
  //             setDisableAgentInput(false)
  //         }

  //     }
  // }

  const handleSourceSystemChange = (index, selectedOptions) => {

    const updatedList = listAgentIds.map((agent, i) => {
      // const isValidSourceSystem = selectedOptions && selectedOptions.length > 0
      // setIsSourceSystemSelected(isValidSourceSystem)
      if (i === index) {
        return {
          ...agent,
          classId: Array.isArray(selectedOptions) ? selectedOptions.map((option) => option.id) : []
        }
      }
      return agent
    })
    setListAgentId(updatedList)
    const currentAgent = updatedList[index]
    const existingData = userIdData?.userCompanies?.filter((item) => Number(item.agentId) === Number(currentAgent.agentId) && Array.isArray(currentAgent.classId) && currentAgent.classId.includes(item.sourceSystemId)
    )
    const filterArray = updatedList.filter((item) => Array.isArray(item.classId) && item.classId.some((id) => currentAgent.classId.includes(id)) && Number(item.agentId) === Number(currentAgent.agentId)
    )
    if (existingData.length > 0) {
      setAgentValidateError(`Agent(${currentAgent.agentId}) with same Source System (${existingData.map(item => SourceSystem(item.sourceSystemId)?.label).join(', ')}) already exists.`)
      setDisableAgentInput(true)
      setDisIndex(index)
    } else if (filterArray.length > 1) {
      setAgentValidateError(`Agent(${currentAgent.agentId}) with same Source System (${currentAgent.classId.map(id => SourceSystem(id)?.label).join(', ')}) already selected.`)
      setDisableAgentInput(true)
      setDisIndex(index)
    } else {
      if (AgentValidateError.includes(currentAgent?.agentId) === false) {

      } else {
        setAgentValidateError('')
        setDisableAgentInput(false)
        setDisIndex("notRequired")
      }

    }
  }

  const handleSourceSystemDelete = (index, id) => {
    const updatedList = [...listAgentIds]
    updatedList[index].classId = updatedList[index].classId.filter((classId) => classId !== id)
    setListAgentId(updatedList)
    const currentAgent = updatedList[index]
    const existingData = userIdData?.userCompanies?.filter((item) => {
      return (
        Number(item.agentId) === Number(currentAgent.agentId) &&
        Array.isArray(currentAgent.classId) &&
        currentAgent.classId.includes(item.sourceSystemId)
      )
    })
    const filterArray = updatedList.filter((item) => {
      return (
        Array.isArray(item.classId) &&
        item.classId.some((id) => currentAgent.classId.includes(id)) &&
        Number(item.agentId) === Number(currentAgent.agentId)
      )
    })
    if (existingData.length > 0) {
      setAgentValidateError(`Agent(${currentAgent.agentId}) with same Source System (${existingData.map(item => SourceSystem(item.sourceSystemId)?.label).join(', ')}) already exists.`)
      setDisableAgentInput(true)
      setDisIndex(index)
    } else if (filterArray.length > 1) {
      setAgentValidateError(`Agent(${currentAgent.agentId}) with same Source System (${currentAgent.classId.map(id => SourceSystem(id)?.label).join(', ')}) already selected.`)
      setDisableAgentInput(true)
      setDisIndex(index)
    } else {
      setAgentValidateError('')
      setDisIndex("notRequired")
      setDisableAgentInput(false)
    }
  }

  const [courseArray, setCourseArray] = useState([])
  const toggle = id => {
    const coursesArr = [...courseArray]
    if (coursesArr.find(find => find === id)) {
      coursesArr.splice(coursesArr.findIndex(find => find === id), 1)
    } else {
      coursesArr.push(id)
    }
    setCourseArray(coursesArr)
  }

  useEffect(() => {
    if (listAgentIds?.length > 0) {
      const generateArray = (length) => Array.from({ length }, (_, i) => (i + 1).toString())
      setCourseArray(generateArray(listAgentIds?.length))
    }
  }, [listAgentIds?.length])

  return (
    !spinnerStatus ? (<div>
      {(modal || infoModal || actionModal || modalInvite) && <Modal isOpen={modal || infoModal || actionModal || modalInvite} toggle={() => updateNo()} color='primary' className='modal-dialog-centered'>
        <ModalHeader toggle={() => updateNo()}>{modalInvite ? "Invite User" : modal ? "Making Address Inactive" : infoModal ? "Update Information" : filteredCompanies[actionIndex]?.isActive ? "Remove Mapping" : "Make Mapping"}</ModalHeader>
        <ModalBody className='p-2'>
          <div>
            {modalInvite ? "Are you sure you want to invite user to Client Portal ?" : modal ? "Please confirm if you wish to mark this User Address as Inactive." : infoModal ? "Please confirm if you wish to proceed with updating the information." : filteredCompanies[actionIndex].isActive ? "Please confirm if you wish to remove this mapping." : "Please confirm if you wish to activate this mapping."}
          </div>
        </ModalBody>
        {<ModalFooter className='p-0 d-block' style={{ border: 0, marginTop: '30px' }}>
          <div className='model_popup_panel model_popup_submit_btn' style={{ justifyContent: 'center' }}>
            <Button color='secondary' onClick={() => updateNo()} className='me-1 reset_button_view btn-cancel'> {modalInvite ? "No" : "Cancel"}  </Button>
            {
              !modalSpinnerStatus ? (
                <Button color='secondary' onClick={() => updateYes()} className='create_submit_btn' >{modalInvite ? "Yes" : modal ? "In Active" : infoModal ? "Update" : filteredCompanies[actionIndex]?.isActive ? "Yes, Remove" : "Yes, Activate"}</Button>
              ) : (
                <Button className='me-1' color='secondary' type='submit'>
                  <Spinner size='sm' />
                  <span className='mx-50'>Loading...</span>
                </Button>
              )}
          </div>
        </ModalFooter>}
      </Modal>}
      <Sidebar
        size="sm"
        open={show}
        title={sideBarValue === "address" ? backupData?.[sideBarIndex]?.newEntry === 1 ? `Add Address Details` : 'Edit Address Details' : `User Company Mapping`}
        headerClassName="mb-1"
        contentClassName="pt-0"
        toggleSidebar={toggleSidebar}
      >
        {(show) ? (
          <div>
            <ModalBody style={{ paddingLeft: '10px', paddingRight: '10px' }}>
              {sideBarValue === "address" ? <div>
                {backupData?.map((addressObj, index) => {
                  if (index === sideBarIndex) {
                    return (
                      <div key={index} className="pb-2 mt-2" style={{ margin: "0px 0px" }}>
                        {index === 0 && backupData[0].newEntry === 1 && <Col className="mt-2">
                          {<Select
                            classNamePrefix="select"
                            options={optionAdrress}
                            value={createAddressOption}
                            onChange={(val) => {
                              setCreateAddressOption(val)
                            }}
                            className={classnames('react-select', { 'is-invalid': errors['country'] })}
                            // isDisabled
                            placeholder={`Address Type`}
                            styles={selectStyles}
                            components={{ ValueContainer: CustomValueContainer }}
                          />}
                        </Col>}
                        <Col className='form_input_wrapper_bootstarpping'>
                          <div className='input-wrapper mt-2'>
                            <Input
                              type='textarea'
                              //  style={errorMessage[index]?.address1 === "" ? {} : { border: "1px solid red" }}
                              rows='2'
                              placeholder=''
                              name="address1"
                              // disabled={addressObj?.userAddress?.isEdit}
                              value={addressObj ? addressObj?.userAddress?.address1 : ''}
                              onChange={(e) => {
                                if (true) {
                                  onChangeInput(e, index, "address1")
                                }
                              }
                              }
                            />
                            <Label className='form-label input_label' for='address1'>
                              Address 1<span className='text-danger'>*</span>
                            </Label>
                            <div style={{ color: "red", fontSize: "14px" }}>{errorMessage[index]?.address1 === "" ? "" : errorMessage[index]?.address1}</div>
                          </div>
                        </Col>
                        <Col className='form_input_wrapper_bootstarpping'>
                          <div className='input-wrapper mt-2'>
                            <Input
                              type='textarea'
                              rows='2'
                              placeholder=''
                              name="address2"
                              //  disabled={addressObj?.userAddress?.isEdit}
                              value={addressObj ? addressObj?.userAddress?.address2 : ''}
                              onChange={(e) => {
                                if (true) {
                                  onChangeInput(e, index, "address2")
                                }
                              }
                              }
                            />
                            <Label className='form-label input_label' for='address2'>
                              Address 2
                            </Label>
                            <div style={{ color: "red", fontSize: "14px" }}>{errorMessage[index]?.address2 === "" ? "" : errorMessage[index]?.address2}</div>
                          </div>
                        </Col>
                        <Col className='form_input_wrapper_bootstarpping'>
                          <div className='input-wrapper mt-2' >
                            <Input placeholder=''
                              type="text"
                              //   style={errorMessage[index]?.city === "" ? {} : { border: "1px solid red" }}
                              value={addressObj ? addressObj?.userAddress?.city : ''}
                              // disabled={addressObj?.userAddress?.isEdit}
                              onChange={(e) => {
                                if (true) {
                                  onChangeInput(e, index, "city")
                                }
                              }
                              }
                            />
                            <Label className='form-label input_label' for='city'>
                              City <span className='text-danger'>*</span>
                            </Label>
                            <div style={{ color: "red", fontSize: "14px" }}>{errorMessage[index]?.city === "" ? "" : errorMessage[index]?.city}</div>
                          </div>
                        </Col>

                        <Col className='form_input_wrapper_bootstarpping'>
                          <div className='mt-2'>
                            <Select
                              classNamePrefix="select"
                              options={stores ? sorter("label", "asc", [...stores.countryStates]) : []}
                              value={addressObj?.userAddress?.countryName}
                              //style={errorMessage[index]?.country === "" ? {} : { border: "1px solid red" }}
                              // menuPlacement="auto"
                              // menuPosition="fixed"
                              menuPortalTarget={document.body}
                              onChange={(e) => {
                                onChangeInput(e, index, "countryName")
                              }}
                              className={classnames('react-select', { 'is-invalid': errorMessage[index]?.country })}
                              isClearable
                              //   isDisabled={addressObj?.userAddress?.isEdit}
                              placeholder={`Select Country <span class='text-danger'>*</span>`}
                              styles={selectStyles1}
                              components={{ ValueContainer: CustomValueContainer }}
                            />
                            <div style={{ color: "red", fontSize: "14px" }}>{errorMessage[index]?.country === "" ? "" : errorMessage[index]?.country}</div>
                          </div>
                        </Col>
                        <Col className='form_input_wrapper_bootstarpping'>
                          {addressObj?.userAddress?.countryName?.states?.length > 0 ? (
                            <div className='mt-2'>
                              <Select
                                // inputRef={ref}
                                classNamePrefix="select"
                                options={sorter("label", "asc", [
                                  ...addressObj?.userAddress?.countryName?.states?.map((item) => {
                                    return { ...item, label: item.name, value: item.name }
                                  })
                                ]
                                )}
                                //    style={errorMessage[index]?.state === "" ? {} : { border: "1px solid red" }}
                                menuPortalTarget={document.body}
                                // menuPlacement="auto"
                                // menuPosition="fixed"
                                // isDisabled={addressObj?.userAddress?.isEdit}
                                value={addressObj?.userAddress?.state}
                                onChange={(val) => { onChangeInput(val, index, "state") }}
                                className={classnames('react-select', { 'is-invalid': errorMessage[index]?.state })}
                                isClearable
                                placeholder={`Select State`}
                                styles={selectStyles1}
                                components={{ ValueContainer: CustomValueContainer }}
                              />
                              <div style={{ color: "red", fontSize: "14px" }}>{errorMessage[index]?.state === "" ? "" : errorMessage[index]?.state}</div>
                            </div>
                          ) : (
                            <div className='input-wrapper mt-2'>
                              <Input placeholder='' value={addressObj?.userAddress?.state?.label}
                                // disabled={addressObj?.userAddress?.isEdit}
                                onChange={(val) => { onChangeInput(val, index, "state") }} />
                              <Label className='form-label input_label' for='state'>
                                State
                              </Label>
                            </div>
                          )}
                        </Col>
                      </div>
                    )
                  }
                })}
                {/* </div> : <div>
                                <div className='select_create mt-1' >
                                    <Select
                                        // ref={selectRefs}
                                        isClearable
                                        onChange={(val) => {

                                            if (val?.agentId) {
                                                const bufferList = [...listAgentIds]
                                                bufferList.push(val)
                                                const addAgentIfNotExist = (agents, val) => {
                                                    console.log(val, "val")
                                                    const existingData = userIdData?.userCompanies?.filter((item) => item.agentId === Number(val.agentId))
                                                    if (existingData.length) {
                                                        existingData.forEach((item) => {
                                                            if (item.agentId && val?.agentId && item.sourceSystemId === val.classId) {
                                                                setAgentValidateError(`Agent(${val.agentId}) with same Source System (${SourceSystem(val.classId)?.label})  already exists.`)
                                                                setDisableAgentInput(true)
                                                            }
                                                        })
                                                    }
                                                    const fitlerArray = listAgentIds.filter((item) => item.classId === val.classId && Number(item.agentId) === Number(val.agentId))
                                                    if (fitlerArray.length > 0) {
                                                        setDisIndex(listAgentIds.length + 1)
                                                        setAgentValidateError(`Agent(${val.agentId}) with same Source System (${SourceSystem(val.classId)?.label})  already selected.`)
                                                        setDisableAgentInput(true)
                                                    }
                                                    if (bufferList.length) {
                                                        setAgentError('')
                                                    }
                                                    agents.push(val)
                                                    setListAgentId(agents)

                                                }
                                                addAgentIfNotExist(listAgentIds, val)
                                                setAgentObj({})
                                            }
                                        }}
                                        inputValue={agentInput}
                                        classNamePrefix="select"
                                        options={companyData}
                                        value={agentObj?.label ? null : null}
                                        components={{ NoOptionsMessage, ValueContainer: CustomValueContainer }}
                                        styles={selectStyles}
                                        className={classnames('react-select')}
                                        onInputChange={handleInputChange}
                                        isLoading={isLoading}
                                        loadingMessage={() => 'Loading...'}
                                        placeholder={`Select AgentId or Name<span class='text-danger'>*</span>`}
                                        id='showAgentTooltip'
                                        isDisabled={disableAgentInput}
                                    />
                                </div>
                                {agentError.length ? <div style={{ marginTop: "10px", color: "red", fontSize: "14px" }}>{agentError}</div> : ""}

                                <Col>
                                    <div >
                                        {console.log(listAgentIds, "listAgentIds")}
                                        {listAgentIds.map((item, index) => (
                                            <div key={index} className=' mt-1'>
                                                <p className='display-filter-val' style={{ float: "none", width: "max-content" }}>
                                                    {item.label}
                                                    <span
                                                        onClick={() => handleDelete(index)}
                                                        className='cross_mark'
                                                        style={{ fontWeight: "900", cursor: "pointer" }}
                                                    >
                                                        X
                                                    </span>
                                                </p>
                                                <div>
                                                    <Select
                                                        classNamePrefix="select"
                                                        options={SourceSystem("options")}
                                                        value={SourceSystem(item.classId)}
                                                        isDisabled={typeof (disIndex) && disIndex === index}
                                                        onChange={(val) => handleSourceSystemChange(index, val)}
                                                        className={classnames('react-select', { 'is-invalid': false })}
                                                        placeholder={`SourceSystem Type`}
                                                        styles={selectStyles}
                                                        components={{ ValueContainer: CustomValueContainer }}
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    {AgentValidateError.length ? < div style={{ marginTop: "10px", color: "red", fontSize: "14px" }}>{AgentValidateError}</div> : ""}

                                </Col>
                            </div>}  */}

              </div> : <div>
                <Col>
                  <div className='select_create mt-1' >
                    <Select
                      // ref={selectRefs}
                      isClearable
                      onChange={(val) => {
                        if (val?.agentId) {
                          const preExistingData = userIdData?.userCompanies.filter((item) => item.agentId === val.value && val.classId === item.sourceSystemId)
                          if (preExistingData.length) {
                            setAgentValidateError(
                              `Agent(${val.agentId}) with same Source System (${SourceSystem(val.classId)?.label}) already exists.`
                            )
                            // toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                            //  setDisableAgentInput(true)

                          }

                          const bufferList = [...listAgentIds]
                          const agentExists = listAgentIds.some((agent) => agent.agentId === val.agentId)
                          if (!agentExists) {
                            bufferList.push(val)
                            const addAgentIfNotExist = (agents, val) => {
                              const existingData = userIdData?.userCompanies?.filter(
                                (item) => item.agentId === Number(val.agentId)
                              )
                              if (existingData.length) {
                                existingData.forEach((item) => {
                                  if (item.agentId && val?.agentId && item.sourceSystemId === val.classId) {
                                    setAgentValidateError(
                                      `Agent(${val.agentId}) with same Source System (${SourceSystem(val.classId)?.label}) already exists.`
                                    )
                                    // toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                                    setDisableAgentInput(true)
                                  }
                                })
                              }
                              const classIdArray = [val.classId]
                              val["classId"] = classIdArray
                              const fitlerArray = listAgentIds.filter((item) => item.classId === val.classId[0] && Number(item.agentId) === Number(val.agentId)
                              )
                              if (fitlerArray.length > 0) {
                                setDisIndex(listAgentIds.length + 1)
                                setAgentValidateError(
                                  `Agent(${val.agentId}) with same Source System (${SourceSystem(val.classId[0])?.label}) already selected.`
                                )
                                setDisableAgentInput(false)
                              }
                              if (bufferList.length) {
                                setAgentError('')
                              }
                              agents.push(val)
                              setListAgentId(agents)
                            }
                            addAgentIfNotExist(listAgentIds, val)
                            setAgentObj({})
                          } else {
                            toast(t => (<ToastMessage t={t} message={"agent already selected"} status={"danger"} />))
                          }
                        }
                      }}
                      inputValue={agentInput}
                      classNamePrefix="select"
                      options={companyData}
                      value={agentObj?.label ? null : null}
                      components={{ NoOptionsMessage, ValueContainer: CustomValueContainer }}
                      styles={selectStyles}
                      className={classnames('react-select')}
                      onInputChange={handleInputChange}
                      isLoading={isLoading}
                      loadingMessage={() => 'Loading...'}
                      placeholder={`Select AgentId or Name<span class='text-danger'>*</span>`}
                      id='showAgentTooltip'
                      isDisabled={disableAgentInput}
                    />
                  </div>
                  {agentError.length ? <div style={{ marginTop: "10px", color: "red", fontSize: "14px" }}>{agentError}</div> : ""}
                </Col>
                <Col>
                  <div className='listAgents'>
                    {listAgentIds.map((item, index) => {
                      const agentAlreadySelected = listAgentIds.some((agent) => agent.agentId === item.agentId)
                      const indexValue = String(index + 1)
                      const preExistingData = userIdData?.userCompanies.filter((find) => find.agentId === item.agentId && item.classId.includes(find.sourceSystemId))
                      return (
                        <div className='mt-1'>
                          <Accordion className='accordion-border' open={courseArray.find(find => find === indexValue) ? courseArray.find(find => find === indexValue) : ''} toggle={toggle} style={{ marginBottom: '15px' }}>
                            <AccordionItem open={courseArray.find(find => find === indexValue) ? courseArray.find(find => find === indexValue) : ''}>
                              <AccordionHeader targetId={indexValue} className={'accordian-head acc-item'}>
                                <div className='d-flex w-100'>
                                  <div style={{ width: '95%', fontSize: '15px', marginLeft: '10px', marginTop: courseArray.find(find => find === indexValue) ? '3px' : '0px', color: preExistingData.find(find => find.agentId === item.agentId) ? 'red' : '#00ADC3'}}>
                                    {item?.label}
                                  </div>
                                  <div>|</div>
                                  <div className='text-right' id={`clear_${item?.agentId}`}>
                                    <span
                                      onClick={(e) => {
                                        e.stopPropagation()
                                        handleDelete(index)
                                      }}
                                      className='cross_mark'
                                      style={{ fontWeight: "900", cursor: "pointer", float: 'right', fontSize: '14px', marginTop: '2px' }}
                                    > X </span>
                                  </div>
                                  <UncontrolledTooltip placement='bottom' target={`clear_${item?.agentId}`}>Remove</UncontrolledTooltip>
                                </div>
                              </AccordionHeader>
                              <AccordionBody accordionId={indexValue}>
                                <div key={index} className=' mt-1'>
                                {/* <p className='display-filter-val' 
                                style={{ float: "none"
                                // , width: "max-content" 
                                }}>
                                  {item.label}
                                  <span
                                    onClick={() => handleDelete(index)}
                                    className='cross_mark'
                                    style={{ fontWeight: "900", cursor: "pointer", float: 'right' }}
                                  >
                                    X
                                  </span>
                                </p> */}
                                  <div className='mt-1'>
                                    {agentAlreadySelected && (
                                      <Select
                                        isMulti={true}
                                        classNamePrefix="select"
                                        options={SourceSystem("options")}
                                        value={item.classId ? Array.isArray(item.classId) ? item.classId.map((id) => SourceSystem(id)) : [SourceSystem(item.classId)] : []}
                                        onChange={(val) => handleSourceSystemChange(index, val)}
                                        className={classnames('react-select', { 'is-invalid': false })}
                                        placeholder={`Select Source System Type`}
                                        styles={selectStyles}
                                        components={{
                                          NoOptionsMessage,
                                          ValueContainer: SourceSystemCustomContainer
                                        }}
                                      />
                                    )}
                                  </div>
                                  <div style={{ marginTop: '10px', display: 'none' }} className='label_sourceSystem_container'>
                                    {item.classId && item.classId.length > 0 && (
                                      item.classId.map((id, idx) => (
                                        <p key={idx} className="display-filter-val label_sourceSystem " style={{ float: "none", width: "max-content" }}>
                                          {SourceSystem(id)?.label}
                                          <span
                                            onClick={() => handleSourceSystemDelete(index, id)}
                                            className="cross_mark"
                                            style={{ fontWeight: "900", cursor: "pointer", marginLeft: '5px' }}
                                          >
                                            X
                                          </span>
                                        </p>
                                      ))
                                    )}
                                  </div>
                                  {(item.classId && item.classId.length > 0) &&
                                    <div className='d-flex mt-2' style={{ justifyContent: "space-between" }}>
                                      <table className="table table-striped table-bordered">
                                        <thead>
                                          <tr>
                                            <th>Source System</th>
                                            <th>End Date</th>
                                            <th>Action</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {item.classId && item.classId.length > 0 && (item.classId.map((id, idx) => {
                                              const listAgentIdsData = [...listAgentIds]
                                              const agentAlreadySelectedData = listAgentIdsData.find((agent) => agent.agentId === item.agentId)
                                              const endDates = agentAlreadySelectedData?.endDates ? agentAlreadySelectedData?.endDates : []
                                              const findId = endDates.find(find => find.id === id)
                                              return (
                                                <tr key={id}>
                                                  <td style={{ fontSize: '14px' }}>{SourceSystem(id)?.label}</td>
                                                  <td>
                                                    <div className='input-wrapper'>
                                                      <Flatpickr
                                                        ref={el => { 
                                                          fpRefs.current[makeKey(item.agentId, id)] = el 
                                                        }}
                                                        placeholder=""
                                                        value={findId?.endDate}
                                                        className={`form-control`}
                                                        options={{
                                                          dateFormat: 'Y-m-d',
                                                          minDate: 'today'
                                                        }}
                                                        onChange={(dates, dateString) => {
                                                          const listAgentIdsData = [...listAgentIds]
                                                          const agentAlreadySelected = listAgentIdsData.find((agent) => agent.agentId === item.agentId)

                                                          if (agentAlreadySelected) {
                                                            const endDates = agentAlreadySelected?.endDates ? [...agentAlreadySelected.endDates] : []

                                                            const index = endDates.findIndex((find) => find.id === id)

                                                            if (index >= 0) {
                                                              endDates[index].endDate = dateString || null  // ✅ force update
                                                            } else {
                                                              endDates.push({ id, endDate: dateString || null })
                                                            }

                                                            const findAgentIndex = listAgentIdsData.findIndex((agent) => agent.agentId === item.agentId)
                                                            if (findAgentIndex >= 0) {
                                                              listAgentIdsData[findAgentIndex].endDates = endDates
                                                            }

                                                            setListAgentId([...listAgentIdsData]) // ✅ new array to trigger re-render
                                                          }
                                                        }}
                                                        id={makeKey(item.agentId, id)}
                                                        name={makeKey(item.agentId, id)}
                                                      />
                                                      <Label className='form-label input_label' for={makeKey(item.agentId, id)}>
                                                        End Date
                                                      </Label>
                                                      {findId?.endDate ? (
                                                        <div onClick={() => {
                                                          const listAgentIdsData = [...listAgentIds]
                                                          const agentAlreadySelected = listAgentIdsData.find((agent) => agent.agentId === item.agentId)
                                                          if (agentAlreadySelected) {
                                                            const endDates = agentAlreadySelected?.endDates ? agentAlreadySelected?.endDates : []
                                                            const findId = endDates.findIndex(find => find.id === id)
                                                            if (findId >= 0) {
                                                              endDates[findId].endDate = null
                                                            }
                                                            const findAgentIndex = listAgentIdsData.findIndex((agent) => agent.agentId === item.agentId)
                                                            if (findAgentIndex >= 0) {
                                                              listAgentIdsData[findAgentIndex]['endDates'] = endDates
                                                            }
                                                            setListAgentId(listAgentIdsData)
                                                          }
                                                        }} className='clear-icons'>
                                                            <X size={16} strokeWidth={3} />
                                                        </div>
                                                      ) : (
                                                        <div onClick={() => {
                                                          const key = makeKey(item.agentId, id)
                                                          if (fpRefs.current[key]?.flatpickr) {
                                                            fpRefs.current[key].flatpickr.open()
                                                          }
                                                        }} className='clear-icons'>
                                                          <Calendar size={16} strokeWidth={3} />
                                                        </div>
                                                      )}
                                                    </div>
                                                  </td>
                                                  <td>
                                                    <span
                                                      onClick={() => {
                                                        handleSourceSystemDelete(index, id)
                                                        const listAgentIdsData = [...listAgentIds]
                                                        const agentAlreadySelected = listAgentIdsData.find((agent) => agent.agentId === item.agentId)
                                                        if (agentAlreadySelected) {
                                                          const endDates = agentAlreadySelected?.endDates ? agentAlreadySelected?.endDates : []
                                                          const findId = endDates.findIndex(find => find.id === id)
                                                          if (findId >= 0) {
                                                            endDates[findId].endDate = null
                                                          }
                                                          const findAgentIndex = listAgentIdsData.findIndex((agent) => agent.agentId === item.agentId)
                                                          if (findAgentIndex >= 0) {
                                                            listAgentIdsData[findAgentIndex]['endDates'] = endDates
                                                          }
                                                          setListAgentId(listAgentIdsData)
                                                        }
                                                      }}
                                                      className="cross_mark"
                                                      style={{ fontWeight: "900", cursor: "pointer" }}
                                                    >
                                                      Remove
                                                    </span>
                                                  </td>
                                                </tr>
                                              ) 
                                            })
                                          )}
                                        </tbody>
                                      </table>
                                    </div>
                                  }
                                  {preExistingData?.length > 0 &&
                                  <div style={{ marginTop: "10px", color: "red", fontSize: "14px" }}>Source System ({preExistingData.map(item => SourceSystem(item.sourceSystemId)?.label).join(', ')}) already exists.</div>
                                  }
                                  {/* {index === 0 && listAgentIds.length > 1 && (
                                    <hr style={{ margin: '25px 0', border: '1px solid #ccc' }} />
                                  )} */}
                                </div>
                              </AccordionBody>
                              </AccordionItem>
                          </Accordion>
                        </div>
                      )
                    })}
                  </div>
                  {/* {AgentValidateError.length ? < div style={{ marginTop: "10px", color: "red", fontSize: "14px" }}>{AgentValidateError}</div> : ""} */}
                </Col>
                {listAgentIds?.length > 0 &&
                  <Col className='d-none'>
                    <div className='input-wrapper'>
                      <Flatpickr
                        ref={fpRef}
                        placeholder=""
                        value={endDate}
                        className={`form-control`}
                        options={{
                          dateFormat: 'Y-m-d'
                        }}
                        onChange={(date, dateString) => {
                          setEndDate(dateString)
                        }}
                        id={`endDate`}
                        name='endDate'
                      />
                      <Label className='form-label input_label' for={`endDate`}>
                        End Date
                      </Label>
                      {endDate ? (
                        <div onClick={() => {
                            setEndDate(null)
                        }} className='clear-icon'>
                            <X size={16} strokeWidth={3} />
                        </div>
                      ) : (
                        <div onClick={() => {
                          if (fpRef?.current?.flatpickr) {
                            fpRef?.current?.flatpickr.open()
                          }
                        }} className='clear-icon'>
                          <Calendar size={16} strokeWidth={3} />
                        </div>
                      )}
                    </div>
                  </Col>
                }
              </div>}
            </ModalBody>
            <ModalFooter className='p-0 d-block' style={{ border: 0, marginTop: '30px' }}>
              <Row>
                <Col sm='12' md='12' lg='12' xl='12' className='p-0 mt-1'>
                  <div className='model_popup_panel model_popup_submit_btn model_popup_footer_fixed' style={{ justifyContent: 'center', padding: "12px 0px", display: "flex", background: "unset" }}>
                    {sidebarSpinnerStatus ? (
                      <Button.Ripple color='primary' disabled={sidebarSpinnerStatus} style={{ paddding: "0px 0px" }}>
                        <Spinner size='sm' />
                        <span className='mx-50'>Loading...</span>
                      </Button.Ripple>
                    ) : (
                      <Fragment>
                        <Button className='me-1 reset_button_view' outline color='secondary' style={{ paddding: "0px 0px" }} onClick={() => handleReset()}>
                          <RefreshCcw size={14} className='align-middle me-sm-25 me-0' />
                          <span className='align-middle d-sm-inline-block mx-50'>Reset</span>
                        </Button>
                        <Button className='create_submit_btn' style={{ paddding: "0px 0px" }} disabled={AgentValidateError || agentError.length || listAgentIds.length === 0 || listAgentIds.some(agent => agent.classId.length === 0)} onClick={() => {
                          if (sideBarValue === "address") {
                            updateAddressFunction(sideBarIndex)
                          } else {
                            AgentCallFunction()
                          }
                        }}>
                          {/* <Check size={18} className='align-middle me-sm-25 me-0'></Check> */}
                          {(sideBarValue !== "address" || backupData[0].newEntry === 1) ? <Plus size={18} /> : ""}
                          <span className='align-middle d-sm-inline-block mx-50'>{sideBarValue === "address" ? backupData[0].newEntry === 1 ? 'Add' : "Update" : "Add"}</span>
                        </Button>
                      </Fragment>
                    )}
                  </div>
                </Col>
              </Row>
            </ModalFooter>
          </div>
        ) : (
          <ComponentSpinner />
        )}
      </Sidebar >
      <Row className="card_style pt-2 pb-2" style={{ margin: "0px 0px" }}>
        <Col sm='12' md='12' lg='12' xl='12'>
          <span className='headers-style mt-1' style={{ fontWeight: 500 }}>User Information <span style={{ marginLeft: "-5px" }}>
            {!userDetailsDisabling && userWriterRole() && loggedinUserDetails.userRoles[0].roleId === 1 && <span className='headers-style mt-3 mx-2' style={{ cursor: "pointer" }} onClick={() => {
              setUserDetailsDisabling(!userDetailsDisabling)
            }}>
              <Edit size={18}></Edit></span>}</span></span>
        </Col>
        <Col sm='12' md='12' lg='4' xl='4'>
          <div className='input-wrapper mt-2'>
            <Controller
              defaultValue={userIdData ? userIdData?.user?.firstName : ''}
              control={control}
              id='firstName'
              name='firstName'
              render={({ field: { onChange } }) => <Input
                placeholder=''
                invalid={errors.firstName && true}
                value={firstName}
                disabled={!userDetailsDisabling}
                onChange={(val) => {
                  onChange(val, setFirstName(val.target.value))
                  if (val.target.value !== firstName) {

                  }
                }} />}
            />
            <Label className='form-label input_label' for={`firstName`}>
              First Name <span className='text-danger'>*</span>
            </Label>
            {errors.firstName && <FormFeedback>{errors.firstName.message}</FormFeedback>}
          </div>
        </Col>
        <Col sm='12' md='12' lg='4' xl='4'>
          <div className='input-wrapper mt-2'>
            <Controller
              defaultValue={userIdData ? userIdData?.user?.lastName : ''}
              control={control}
              id=''
              name='lastName'
              render={({ field: { onChange } }) => <Input
                placeholder=''
                invalid={errors.lastName && true}
                value={lastName}
                disabled={!userDetailsDisabling}
                onChange={(val) => {
                  onChange(val, setLastName(val.target.value))
                  if (val.target.value !== lastName) {

                  }
                }} />}
            />
            <Label className='form-label input_label' for={`lastName`}>
              Last Name <span className='text-danger'>*</span>
            </Label>
            {errors.lastName && <FormFeedback>{errors.lastName.message}</FormFeedback>}
          </div>
        </Col>
        <Col sm='12' md='12' lg='4' xl='4'>
          <div className='input-wrapper mt-2'>
            <Controller
              defaultValue={userIdData ? userIdData?.user?.email : ''}
              control={control}
              id='email'
              name='email'
              render={({ field: { onChange } }) => <Input
                placeholder=''
                invalid={errors.email && true}
                value={email}
                disabled={true}
                onChange={(val) => { onChange(val, setEmail(val.target.value)) }} />}
            />
            <Label className='form-label input_label' for={`email`}>
              Email<span className='text-danger'>*</span>
            </Label>
          </div>
        </Col>
        <Col sm='12' md='12' lg='4' xl='4' className="mt-2">
          {/* <div className='input-wrapper mt-2 d-flex'>
                        <div>status:</div><div className='mx-1'>{userIdData?.user?.status || 1}</div>
                    </div> */}
          <div>
            <Select
              classNamePrefix="select"
              options={options}
              value={statusOption}
              onChange={(val) => {
                setStatus(val)
                if (val.label !== statusOption.label) {

                }
              }}
              isDisabled={!userDetailsDisabling}
              className={classnames('react-select', { 'is-invalid': errors['country'] })}
              placeholder={`Select Status`}
              styles={selectStyles}
              components={{ ValueContainer: CustomValueContainer }}
            />
          </div>
        </Col>
        {(((userIdData?.user?.regionId) || loggedinUserDetails?.userRoles[0]?.roleId === 1) && domain(userIdData?.userEmail)) ? <Col sm='12' md='12' lg='4' xl='4' className="mt-2">
          {<div>
            <Select
              classNamePrefix="select"
              options={regionalOffices}
              value={regionalOffices.find((item) => item.id === selectedRegionId) ?? null}
              onChange={(val) => {
                if (val) {
                  setSelectedRegionId(val.id)
                } else {
                  setSelectedRegionId(-1)
                }
              }}
              isClearable
              isDisabled={!userDetailsDisabling || loggedinUserDetails.userRoles[0].roleId !== 1}
              className={classnames('react-select', { 'is-invalid': errors['country'] })}
              placeholder={`Select Region Office`}
              styles={selectStyles}
              components={{ ValueContainer: CustomValueContainer }}
            />
            {/* <MultiSelect
                            options={selectedSourceSystem?.details ?? []}
                            value={selectedCompany}
                            onChange={(selectedOptions) => {
                                setSelectedCompany(selectedOptions)

                            }}
                            // menuPortalTarget={document.body}
                            isSelectAll={true}
                            isClearable
                            isMulti
                            // isDisabled={title === "Deactivate Discount"}
                            placeholder={`Select Companies <span class='text-danger'>*</span>`}
                            components={{ ValueContainer: CustomValueContainer1 }}
                        // menuShouldScrollIntoView={true}
                        /> */}
          </div>}
        </Col> : ""}
        {loggedinUserDetails?.userRoles[0]?.roleId === 1 && <Col sm='12' md='12' lg='4' xl='4'>
          <div className='model_popup_panel model_popup_submit_btn mt-1' style={{ justifyContent: 'start', textAlign: "left" }}>
            {!inviteSpinner ? (
              <Button
                color='secondary'
                onClick={async () => {
                  setModalInvite(true)
                }}
                disabled={userDetailsDisabling}
                style={{ cursor: userDetailsDisabling ? "not-allowed" : "pointer" }}
                className='create_submit_btn'
              >
                Invite User
              </Button>
            ) : (
              <Button className='me-1' color='secondary' type='submit' disabled>
                <Spinner size='sm' />
                <span className='mx-50'>Loading...</span>
              </Button>
            )}
          </div>

        </Col >}
        <Col sm='12' md='12' lg='4' xl='4'>
          {userDetailsDisabling && <div className='input-wrapper mt-1'>
            <div className='model_popup_panel model_popup_submit_btn' style={{ justifyContent: 'start', textAlign: "left" }}>
              <Button color='secondary' onClick={() => cancel()} className='me-1 reset_button_view btn-cancel' disabled={Object.keys(errors).length}> Cancel </Button>
              {
                spinnerUStatus ? (
                  <Button color='secondary' onClick={() => setInfoModal(!infoModal)} className='create_submit_btn' disabled={(userIdData?.userFirstName === firstName && userIdData?.userLastName === lastName && userIdData?.userStatus === statusOption?.id && (userIdData?.regionId && (userIdData?.regionId === selectedRegionId))) || (!firstName || !lastName)} >Update</Button>
                ) : (
                  <Button className='me-1' color='secondary' disabled={!spinnerUStatus}>
                    <Spinner size='sm' />
                    <span className='mx-50'>Loading...</span>
                  </Button>
                )}
            </div>
            {/* <div className='model_popup_submit_btn' style={{ textAlign: "start" }}>
                            {spinnerUStatus ? (
                                <Button color='secondary' onClick={() => userUpdateFunction()} className='create_submit_btn'>Update</Button>
                            ) : (
                                <Button className='me-1' color='secondary' type='submit' disabled={!spinnerUStatus}>
                                    <Spinner size='sm' />
                                    <span className='mx-50'>Loading...</span>
                                </Button>
                            )}
                        </div> */}
          </div>}
        </Col>
      </Row>
      {
        true ? <Row className="card_style pb-2 mt-2" style={{ margin: "0px" }}>
          <Col sm='6' md='6' lg='6' xl='6' className="mt-1">
          {<div className='sub_header-style' style={{ fontWeight: 500 }}>User Companies List</div>}
          </Col>
          {userWriterRole() && (
            <Col sm='6' md='6' lg='6' xl='6' className="mt-1">
              {backupData[0]?.newEntry !== 1 && loggedinUserDetails?.userRoles[0]?.roleId && <Button
                className='btn-next me-1 next_btn_panel'
                color='primary'
                style={{ padding: "0.7rem", marginTop: "5px", float: 'right' }}
                size='sm'
                onClick={() => {
                  setSideBarValue("mapping")
                  setShow(!show)

                }}
              >
                <Plus size={18} />
                <span className='align-middle ms-25'>Add New Mapping</span>
              </Button>}
            </Col>
          )}
          {/* {<Col sm='6' md='6' lg='8' xl='8' className="mt-1 statusesAlign" >
                        <Input
                            style={{ marginTop: "6px" }}
                            type="checkbox"
                            checked={!companyStatus}
                            onChange={handleCheckboxChange}
                        /><span className='mx-1' style={{ fontSize: "14px", color: "#000", fontWeight: 500 }}>All Associated Companies</span>
                    </Col>} */}
          <Row className="">
            <Col sm="12" md="12" lg="12" xl="12" className="mt-1">
              <div style={{ fontSize: "16px", color: "#000", fontWeight: 500 }}>Filter By:</div>
            </Col>
            <Col sm='6' md='6' lg='3' xl='3' className="form_input_wrapper_bootstarpping">
              <div className='input-wrapper mt-2' >
                <Input
                  // className="input-wrapper mt-2"
                  type="text"
                  placeholder=""
                  value={filterCompanyName}
                  onChange={(e) => handleFilterChange('companyName', e.target.value)}
                />
                <Label className='form-label input_label' for='company'>
                  Company Name
                </Label>
              </div>
            </Col>
            <Col sm='6' md='6' lg='3' xl='3' className="form_input_wrapper_bootstarpping">
              <div className='input-wrapper mt-2' >
                <Input
                  // className="input-wrapper mt-2"
                  type="text"
                  placeholder=""
                  value={filterAgentId}
                  onChange={(e) => handleFilterChange('agentId', e.target.value)}
                />
                <Label className='form-label input_label' for='company'>
                  Agent ID
                </Label>
              </div>
            </Col>
            <Col sm='6' md='6' lg='3' xl='3' className="mt-2">
              <Select
                classNamePrefix="select"
                options={SourceSystem("options")}
                isClearable
                value={filterSourceSystemId}
                onChange={(val) => handleFilterChange('sourceSystemId', val)}
                className={classnames('react-select', { 'is-invalid': errors['sourceSystem'] })}
                placeholder="Source System"
                styles={selectStyles}
                components={{ ValueContainer: CustomValueContainer }}
              />
            </Col>
            <Col sm='12' md='12' lg='3' xl='3' className="mt-2" >
              <div>
                <Select
                  classNamePrefix="select"
                  options={statusOptions}
                  value={companyStatus}
                  onChange={(val) => {
                    setCompanyStatus(val)
                    if (val) {
                      fetch(val?.id, addressStatus)
                    }
                  }}
                  className={classnames('react-select', { 'is-invalid': errors['country'] })}
                  placeholder={`Select Status`}
                  styles={selectStyles}
                  components={{ ValueContainer: CustomValueContainer }}
                />
              </div>
            </Col>
            <Col sm="12" md="12" lg="12" xl="12" className="mt-1">
              <div className='model_popup_panel model_popup_submit_btn model_popup_footer_fixed' style={{ padding: "12px 0px", display: "flex", background: "unset" }}>
                {(filterAgentId || filterCompanyName || filterSourceSystemId) && <Button className='me-1 reset_button_view' outline color='secondary' style={{ paddding: "0px 0px" }} onClick={() => {
                  setFilterAgentId("")
                  setFilterCompanyName("")
                  setFilterSourceSystemId(null)
                }}>
                  <RefreshCcw size={14} className='align-middle me-sm-25 me-0' />
                  <span className='align-middle d-sm-inline-block mx-50'>Reset</span>
                </Button>}
              </div>
            </Col>
          </Row>
          <div className='d-flex mt-1' style={{ justifyContent: "space-between" }}>
            <table className="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>Company Name</th>
                  <th>Agent ID</th>
                  <th>Department Name</th>
                  <th>Source System</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Last Modified Date</th>
                  <th>Status</th>
                  {userWriterRole() && (<th>Actions</th>)}
                </tr>
              </thead>
              <tbody>
                {filteredCompanies?.length ? (
                  filteredCompanies.map((company, index) => (
                    <tr key={`${index}-test`}>
                      {userWriterRole() && (
                        <td>
                          <span
                            className="Company_lableview_p2 linkStyle"
                            onClick={() => navigate(`/company/${company.companyId}`)}
                            style={{ cursor: "pointer" }}
                          >
                            {company.companyName}
                          </span>
                        </td>
                      )}
                      {!userWriterRole() && (
                        <td>
                          <span style={{ color: "#00adc3", fontWeight: 500, fontSize: "14px" }}>
                            {company.companyName}
                          </span>
                        </td>
                      )}
                      <td >{company.agentId}</td>
                      <td>{DepartmentMapping(company.clientDepartmentId)}</td>
                      <td>{SourceSystem(company.sourceSystemId)?.label}</td>
                      <td className='text-center'>{company?.startDate ? formattedDateIssueFixed(company?.startDate) : '-'}</td>
                      <td className='text-center'>{company?.endDate ? formattedDateIssueFixed(company?.endDate) : '-'}</td>
                      <td >{formattedDateIssueFixed(company.lastModifiedDate)}</td>
                      <td>{company.isActive ? "Active" : "Inactive"}</td>
                      {userWriterRole() && (
                        <td>
                          {company.isActive ? (
                            <div className="d-flex" style={{ justifyContent: "space-between" }}>
                              <div
                                className="headers-style removeAddress"
                                style={{
                                  width: "100%",
                                  background: "none",
                                  boxShadow: "none",
                                  fontWeight: 400,
                                  fontSize: "14px",
                                  padding: "0px",
                                  textAlign: "left"
                                }}
                                onClick={() => {
                                  setActionIndex(index)
                                  setActionModal(true)
                                }}
                              >
                                {loadingCompanyId === company.companyId ? (
                                  <div>
                                    <Spinner size="sm" />
                                    <span className="mx-50">Loading...</span>
                                  </div>
                                ) : (
                                  <div>
                                    <Trash2 size={18} />
                                    <span className="mx-1">Remove</span>
                                  </div>
                                )}
                              </div>
                            </div>
                          ) : (
                            <div className="d-flex" style={{ justifyContent: "space-between" }}>
                              <div
                                className="headers-style removeAddress"
                                style={{
                                  width: "100%",
                                  background: "none",
                                  boxShadow: "none",
                                  fontWeight: 400,
                                  fontSize: "14px",
                                  padding: "0px",
                                  textAlign: "left",
                                  color: "#00adc3"
                                }}
                                onClick={() => {
                                  setActionIndex(index)
                                  setActionModal(true)
                                  // MakeInActive(company.companyId, company.isActive, company.sourceSystemId)
                                }}
                              >
                                {loadingCompanyId === company.companyId ? (
                                  <div>
                                    <Spinner size="sm" />
                                    <span className="mx-50">Loading...</span>
                                  </div>
                                ) : (
                                  <div>
                                    <Plus size={18} />
                                    <span className="mx-1">Make Active</span>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                        </td>
                      )}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center">
                      No records to display
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Row > : ""
      }
      {
        true ? <Row className="card_style pt-2 pb-2 mt-2 d-none" style={{ margin: "0px", minHeight: "240px" }}>

          <h5 className='headers-style '>User Address Information</h5>
          <Col sm='12' md='6' lg='4' xl='4' className="mt-1">
            {<Select
              classNamePrefix="select"
              options={optionAdrress}
              value={addressOption}
              onChange={(val) => {
                setAddressOption(val)
              }}
              className={classnames('react-select', { 'is-invalid': errors['country'] })}
              // isDisabled
              placeholder={`Address Type`}
              styles={selectStyles}
              components={{ ValueContainer: CustomValueContainer }}
            />}
          </Col>
          {<Col sm='12' md='6' lg='4' xl='4' className="mt-1">
            {backupData[0]?.newEntry !== 1 && loggedinUserDetails?.userRoles[0]?.roleId && <Button
              className='btn-next me-1 next_btn_panel'
              color='primary'
              style={{ padding: "0.7rem", marginTop: "5px" }}
              size='sm'
              onClick={() => {
                const addingData = [...backupData]
                const dummyData = {
                  addressTypeId: backupData.length + 1,
                  isUserMappingActive: true,
                  newEntry: 1,
                  userAddress: {
                    addressTypeId: 1,
                    address1: "",
                    address2: "",
                    city: "",
                    state: "",
                    countryId: "",
                    countryName: "",
                    isAddressActive: true
                  }
                }
                setEditingElement(dummyData)
                addingData.unshift(dummyData)
                const newErrorMessage = [...errorMessage]
                newErrorMessage.unshift({ address1: '', address2: "", city: "", state: "", country: "" })
                setErrorMessage(newErrorMessage)
                const bufferSpinnerArray = [...spinnerArray]
                bufferSpinnerArray.unshift(false)
                setSpinnerArray(bufferSpinnerArray)

                setBackupData(addingData)
                setSideBarIndex(0)
                setSideBarValue("address")
                setShow(!show)
              }}
            >
              <Plus size={18} />
              <span className='align-middle ms-25'>Add New</span>
            </Button>}
          </Col>}
          {<Col sm='12' md='6' lg='4' xl='4' className="mt-1 statusesAlign" >
            <Input
              style={{ marginTop: "6px" }}
              type="checkbox"
              checked={!addressStatus}
              onChange={handleCheckboxChange1}
            /><span className='mx-1' style={{ fontSize: "14px", color: "#000", fontWeight: 500 }}>All Assoicated Addresses</span>
          </Col>}
          <div className="pb-2 mt-2  mb-2" style={{ margin: "0px 0px" }}>
            {backupData?.length ? <Row style={{ margin: "-6px" }}>
              {backupData.map((addressObj, index) => {
                if (addressObj.userAddress.addressTypeId === addressOption.id && backupData[index]?.newEntry !== 1) {
                  return (
                    <Col sm='12' md='6' lg='4' xl='4' key={index} className="mt-1 mb-1" style={{ padding: "0px 7px" }}>
                      <div className='card_style h-100' style={{
                        display: "flex",
                        flexDirection: "column"
                      }}>
                        <div className="pt-1 pb-1 px-1" style={{ width: "93%", margin: "auto" }}>
                          <div className='frist_Company_lableview_p1_warpper d-flex'>
                            <div className='company_ct_lable_warpper1_invoice' >
                              <h6 className='p-0 Company_lableview_p1'>Address 1</h6>
                            </div>
                            <div className='company_ct_lable_warpper_invoice' >
                              <h6 className='p-0 Company_lableview_p2'>{addressObj.userAddress.address1}</h6>
                            </div>
                          </div>

                          <div className='frist_Company_lableview_p1_warpper d-flex'>
                            <div className='company_ct_lable_warpper1_invoice' >
                              <h6 className='p-0 Company_lableview_p1'>Address 2</h6>
                            </div>
                            <div className='company_ct_lable_warpper_invoice' >
                              <h6 className='p-0 Company_lableview_p2'>{addressObj.userAddress.address2 || '-'}</h6>
                            </div>
                          </div>

                          <div className='frist_Company_lableview_p1_warpper d-flex'>
                            <div className='company_ct_lable_warpper1_invoice' >
                              <h6 className='p-0 Company_lableview_p1'>City</h6>
                            </div>
                            <div className='company_ct_lable_warpper_invoice' >
                              <h6 className='p-0 Company_lableview_p2'>{addressObj.userAddress.city}</h6>
                            </div>
                          </div>

                          <div className='frist_Company_lableview_p1_warpper d-flex'>
                            <div className='company_ct_lable_warpper1_invoice' >
                              <h6 className='p-0 Company_lableview_p1'>State</h6>
                            </div>
                            <div className='company_ct_lable_warpper_invoice' >
                              <h6 className='p-0 Company_lableview_p2'>{typeof (addressObj?.userAddress?.state) === "object" ? addressObj?.userAddress?.state?.label : addressObj?.userAddress?.state || '-'}</h6>
                            </div>
                          </div>

                          <div className='frist_Company_lableview_p1_warpper d-flex'>
                            <div className='company_ct_lable_warpper1_invoice' >
                              <h6 className='p-0 Company_lableview_p1'>Country</h6>
                            </div>
                            <div className='company_ct_lable_warpper_invoice' >
                              <h6 className='p-0 Company_lableview_p2'>{getCountry(addressObj.userAddress.countryId).label}</h6>
                            </div>
                          </div>
                          <div className='frist_Company_lableview_p1_warpper d-flex'>
                            <div className='company_ct_lable_warpper1_invoice' >
                              <h6 className='p-0 Company_lableview_p1'>Status</h6>
                            </div>
                            <div className='company_ct_lable_warpper_invoice' >
                              <h6 className='p-0 Company_lableview_p2'>{addressObj.isUserMappingActive ? 'Active' : 'Inactive'}</h6>
                            </div>
                          </div>

                        </div>
                        <div className="d-flex " style={{ justifyContent: "space-between" }}>
                          {<div className='headers-style removeAddress' onClick={() => {
                            setModal(!modal)
                            setSideBarIndex(index)
                          }}>
                            <Trash2 size={18}></Trash2><span className='mx-1'>Remove Address</span></div>}

                          {addressObj.userAddress.isEdit && <div className='headers-style removeAddress' style={{ color: "#00adc3" }} onClick={() => {
                            updateEdit(index)
                          }}>
                            <Edit size={18}></Edit><span className='mx-1'>Edit Address</span></div>}
                        </div>
                      </div>
                    </Col>
                  )
                }
              })}
            </Row> : ""}
          </div>
        </Row > : ""
      }


    </div >) : (
      <ComponentSpinner></ComponentSpinner>
    )
  )
}

export default ActiveUserDesign
